import cn from 'classnames';

export const commonClasses = {
  stepContainer: cn('md:odin-grid md:odin-grid-cols-3 md:odin-gap-6'),
  stepHeader: cn('odin-p-7.5 sm:odin-p-0 sm:odin-col-span-3'),
  form: cn('odin-p-7.5 sm:odin-p-0 odin-col-span-2'),
  formInputsContainer: cn('odin-grid odin-grid-cols-12 odin-gap-6'),
};
